<template>
  <div class="gallery-wrap">
    <vue-gallery
      ref="gallery"
      :images="fileList"
      :index="fileIndex"
      :options="galleryOptions"
      @close="handleClose"
      @click.native="handleclickGallery"
      @onslide="onslide"
    >
      <i
        slot="prev"
        class="iconfont"
        :class="{ 'iconicon-test40': isMobile, 'iconicon-test43': !isMobile }"
      />
      <i
        slot="next"
        class="iconfont"
        :class="{ 'iconicon-test18': isMobile, 'iconicon-test73': !isMobile }"
      />
    </vue-gallery>
  </div>
</template>

<script>
import VueGallery from 'vue-gallery'
import { isMobile } from '@/lib/device'

export default {
  components: {
    VueGallery
  },

  data () {
    return {
      galleryOptions: {},
      fileList: [],
      fileIndex: null
    }
  },

  computed: {
    isMobile () {
      return isMobile
    }
  },

  created () {
    this.$bus.$on('getFileGallery', this.setFileUrl)
  },

  destroyed () {
    this.$bus.$off('getFileGallery')
  },

  methods: {
    async setFileUrl  (fileList, fileIndex) {
      let _this = this
      let currentItem = fileList[fileIndex]

      _this.fileList = fileList.filter(file => file.file_type && file.file_type.indexOf('image') !== -1)

      _this.fileIndex = _this.fileList.findIndex((file, index) => {
        if (file.id && (file.id === currentItem.id)) {
          return true
        } else if (file.uid && (file.uid === currentItem.uid)) {
          return true
        }
      })

      for (let i in _this.fileList) {
        let item = _this.fileList[i]
        let newUrl = await _this.$reSetFileUrl(item.url || item.file_url)
        item.href = newUrl

        let $slideImg = document.documentElement.querySelectorAll('#blueimp-gallery .slides .slide img')
        $slideImg && $slideImg[i] && ($slideImg[i].src = newUrl)
      }
    },

    async onslide ({ index, slide }) {
      this.fileIndex = index
    },

    async handleclickGallery (e) {
      if (!e || !e.target) return
      if (e.target.className === 'slides') return
      if (this.fileIndex === null) return

      if (e.target.className === 'description' || e.target.className === 'slide-content' || e.target.className === 'title') {
        if (isMobile) {
          this.$downloadFile(this.fileList[this.fileIndex].file_url)
        } else {
          if (this.$isDingDing) {
            this.$downloadFile(this.fileList[this.fileIndex].file_url)
          } else {
            this.$downloadFile(this.fileList[this.fileIndex].file_url, 'new')
          }
        }
      }
    },

    handleClose () {
      this.fileIndex = null
      setTimeout(() => {
        document.body.style.overflow = 'auto'
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
.gallery-wrap ::v-deep {
  .blueimp-gallery {
    background: rgba(0, 0, 0, 0.6);
    > .slides {
      > .slide {
        height: 60%;
        top: 10%;
      }
    }
  }

  .blueimp-gallery > .description {
    position: absolute;
    top: 75%;
    left: 0;
    width: 100%;
    text-align: center;
    color: #fff;
    font-size: 14px;
  }
  .blueimp-gallery > .next,
  .blueimp-gallery > .prev,
  .blueimp-gallery > .title {
    top: 90%;
    left: 50%;
    right: 0;
    width: 32px;
    height: 32px;
    margin-top: -16px;
    font-size: 0;
    line-height: 32px;
    background: #fff;
    border-radius: 4px;
    text-shadow: none;
    border: none;
    opacity: 1;
    cursor: pointer;
    .iconfont {
      font-size: 20px;
      color: #333;
    }
  }
  .blueimp-gallery > .prev {
    margin-left: 16px;
  }
  .blueimp-gallery > .next {
    margin-left: 56px;
  }
  .blueimp-gallery > .title {
    width: 82px;
    margin-left: -86px;
    font-size: 14px;
    text-align: center;
    color: #333;
    background-color: #f5f5f5;
  }
  .blueimp-gallery > .close {
    font-size: 32px;
    text-shadow: none;
  }
}
</style>
